import React, { useState, useCallback, useEffect } from 'react';
import {
  Paper,
  Box,
  Button,
  CircularProgress,
} from '@mui/material';
import { useBuild } from '../contexts/BuildContext';
import { useGlobal } from '../contexts/GlobalContext';
import ParamsPolymarketV1 from './polymarket/ParamsPolymarketV1';
import ParamsPolymarketV2 from './polymarket/ParamsPolymarketV2';
import ParamsKalshiV1 from './kalshi/ParamsKalshiV1';
import ParamsTokenItemsV1 from './token_items/ParamsTokenItemsV1';

const StoriesQueryColumn = ({ selectedEngine }) => {
  const { mergeCurrentContext } = useGlobal();
  const { storiesApi, isLoading, updateStoriesEngine } = useBuild();
  const [params, setParams] = useState(null);

  useEffect(() => {
    mergeCurrentContext({
      storiesParamsConfigured: Boolean(params),
    });
    return () => mergeCurrentContext({ storiesParamsConfigured: undefined });
  }, [params, mergeCurrentContext]);

  // Update the storiesEngine in the context whenever selectedEngine changes
  React.useEffect(() => {
    if (selectedEngine) {
      updateStoriesEngine(selectedEngine);
    }
  }, [selectedEngine, updateStoriesEngine]);

  const handleParamsChange = useCallback((updatedParams) => {
    setParams(updatedParams);
  }, []);

  const handleGenerateStories = async () => {
    if (!selectedEngine || !params) {
      return;
    }

    try {
      await storiesApi.generateStories(selectedEngine, params);
    } catch (error) {
      console.error('Error generating stories:', error);
    }
  };

  const renderEngineParams = () => {
    switch (selectedEngine) {
      case 'polymarket_v1':
        return <ParamsPolymarketV1 onParamsChange={handleParamsChange} />;
      case 'polymarket_v2':
        return <ParamsPolymarketV2 onParamsChange={handleParamsChange} />;
      case 'kalshi_v1':
        return <ParamsKalshiV1 onParamsChange={handleParamsChange} />;
      case 'token_items_v1':
        return <ParamsTokenItemsV1 onParamsChange={handleParamsChange} />;
      default:
        return null;
    }
  };

  return (
    <Paper elevation={2} sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      {/* Engine Params */}
      {selectedEngine && (
        <Box sx={{ mb: 2 }}>
          {renderEngineParams()}
        </Box>
      )}

      {/* Generate Button */}
      <Button
        variant="contained"
        color="primary"
        onClick={handleGenerateStories}
        disabled={!selectedEngine || !params || isLoading}
        fullWidth
      >
        {isLoading ? (
          <>
            <CircularProgress size={20} sx={{ mr: 1 }} />
            Generating...
          </>
        ) : (
          'Generate Stories'
        )}
      </Button>
    </Paper>
  );
};

export default StoriesQueryColumn;

